/* Current Nostalgia — Quick View modal (loads the product page section into a dialog) */
(function () {
  if (window.__cnQuickView) return;
  window.__cnQuickView = true;
  var modal, body, lastFocus, n = 0;

  function ensure() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cn-qv';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="cn-qv__backdrop" data-cn-qv-close></div>' +
      '<div class="cn-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<button type="button" class="cn-qv__close" data-cn-qv-close aria-label="Close">' +
      '<svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
      '<div class="cn-qv__body"></div></div>';
    document.body.appendChild(modal);
    body = modal.querySelector('.cn-qv__body');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-cn-qv-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          if (!modal.hidden) close();
        });
      }
    } catch (e) {}
    return modal;
  }

  // In quick view, show only the selected color's photos (alt text is "Product Title Color").
  function filterColor() {
    if (!body) return;
    var groups = body.querySelectorAll('[data-cn-option]');
    var color = null;
    groups.forEach(function (g) {
      var k = g.querySelector('.cn-opt__k');
      if (k && /colou?r/i.test(k.textContent)) {
        var p = g.querySelector('[aria-pressed="true"]');
        if (p) color = p.getAttribute('data-value');
      }
    });
    var slides = body.querySelectorAll('.cn-pdp__slide');
    if (!color || !slides.length) return;
    var suffix = (' ' + color).toLowerCase();
    var matches = Array.prototype.filter.call(slides, function (s) {
      var img = s.querySelector('img');
      return img && (img.getAttribute('alt') || '').toLowerCase().slice(-suffix.length) === suffix;
    });
    if (!matches.length) return;
    slides.forEach(function (s) { s.hidden = matches.indexOf(s) === -1; });
    var gal = body.querySelector('.cn-pdp__gallery');
    if (gal) gal.scrollTop = 0, gal.scrollLeft = 0;
    var count = body.querySelector('.cn-pdp__count');
    if (count) count.hidden = true;
  }

  // Bring the full page's Color/Size picker and "Sizing" guide into the modal.
  function mountExtras(doc) {
    var pdp = body.querySelector('.cn-pdp');
    if (!pdp) return;
    var src = doc.querySelector('[data-cn-size-group]');
    var tpl = doc.getElementById('CnSizeGuideTpl');
    var sec = (src || tpl) && (src || tpl).closest('.shopify-section');
    if (sec) sec.querySelectorAll('style').forEach(function (s) { body.appendChild(document.importNode(s, true)); });

    if (src && src.querySelector('.cn-size-group')) {
      var picker = document.importNode(src.querySelector('.cn-size-group'), true);
      var colors = src.hasAttribute('data-has-colors');
      var re = colors ? /^\s*(size|colou?r)\b/i : /^\s*size\b/i;
      pdp.querySelectorAll('.cn-pdp__fields .cn-field, .cn-pdp__options .cn-opt').forEach(function (f) {
        var k = f.querySelector('.cn-field__k, .cn-opt__k');
        if (k && re.test(k.textContent)) f.hidden = true;
      });
      if (colors) pdp.querySelectorAll('.cn-pdp__label--desktop').forEach(function (el) { el.hidden = true; });
      picker.querySelectorAll('[data-cn-size-link]').forEach(function (a) {
        a.removeAttribute('data-cn-size-link');
        a.setAttribute('data-cn-qv-go', '');
      });
      picker.querySelectorAll('[data-cn-size-select]').forEach(function (s) {
        s.removeAttribute('data-cn-size-select');
        s.setAttribute('data-cn-qv-select', '');
        if (s.id) s.id = s.id + '-qv';
      });
      picker.querySelectorAll('label[for]').forEach(function (l) { l.setAttribute('for', l.getAttribute('for') + '-qv'); });
      var form = pdp.querySelector('.cn-pdp__form');
      if (form) form.parentNode.insertBefore(picker, form);
      var gt = src.getAttribute('data-group-title');
      if (gt) pdp.querySelectorAll('.cn-pdp__title, .cn-pdp__mobile-title').forEach(function (el) { el.textContent = gt; });
    }

    var acc = pdp.querySelector('.cn-acc');
    if (tpl && tpl.content && tpl.content.firstElementChild && acc) {
      var item = document.importNode(tpl.content.firstElementChild, true);
      item.id = 'CnQvSizeGuide';
      try { var saved = localStorage.getItem('cnSizeGuideUnit'); if (saved === 'cm' || saved === 'in') setUnit(item, saved); } catch (e) {}
      var existing = null;
      acc.querySelectorAll('.cn-acc__item').forEach(function (d) {
        var sum = d.querySelector('.cn-acc__summary');
        if (sum && /^\s*(sizing|size guide)\b/i.test(sum.textContent)) existing = existing || d;
      });
      if (existing) existing.replaceWith(item);
      else {
        var first = acc.querySelector('.cn-acc__item');
        acc.insertBefore(item, first ? first.nextSibling : acc.firstChild);
      }
    }
  }

  function setUnit(guide, u) {
    guide.setAttribute('data-unit', u);
    guide.querySelectorAll('[data-cn-sg-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cn-sg-unit') === u ? 'true' : 'false');
    });
  }

  function close() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('cn-qv-open');
    body.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function open(url, trigger) {
    ensure();
    if (trigger) lastFocus = trigger;
    body.innerHTML = '<p class="cn-qv__loading">Loading…</p>';
    modal.hidden = false;
    document.documentElement.classList.add('cn-qv-open');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pdp = doc.querySelector('.cn-pdp');
        if (!pdp) throw new Error('no product section');
        var wrap = pdp.closest('.shopify-section') || pdp.parentElement;
        var sid = pdp.getAttribute('data-section');
        var nid = 'cnqv' + ++n;
        body.innerHTML = sid ? wrap.innerHTML.split(sid).join(nid) : wrap.innerHTML;
        body.querySelectorAll('script').forEach(function (old) {
          if (old.type === 'application/ld+json') { old.remove(); return; }
          var s = document.createElement('script');
          Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
          s.textContent = old.textContent.replace(/window\.history\.replaceState\([^;]*\);/g, '');
          old.replaceWith(s);
        });
        mountExtras(doc);
        var box = body.querySelector('.cn-pdp__buybox');
        if (box) {
          var a = document.createElement('a');
          a.className = 'cn-qv__full';
          a.href = url;
          a.textContent = 'View full details';
          box.appendChild(a);
        }
        filterColor();
        var c = modal.querySelector('.cn-qv__close');
        if (c) c.focus();
      })
      .catch(function () { window.location.href = url; });
  }

  document.addEventListener('click', function (e) {
    if (modal && !modal.hidden && e.target.closest('.cn-qv .cn-opt__btn')) setTimeout(filterColor, 0);
    var go = e.target.closest('.cn-qv [data-cn-qv-go]');
    if (go) {
      e.preventDefault();
      if (go.getAttribute('aria-current') !== 'true') open(go.getAttribute('href'));
      return;
    }
    var u = e.target.closest('.cn-qv [data-cn-sg-unit]');
    if (u) {
      var g = u.closest('.cn-sg');
      var unit = u.getAttribute('data-cn-sg-unit');
      if (g) setUnit(g, unit);
      try { localStorage.setItem('cnSizeGuideUnit', unit); } catch (err) {}
    }
    var b = e.target.closest('[data-cn-qv]');
    if (!b) return;
    e.preventDefault();
    open(b.getAttribute('data-cn-qv'), b);
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('.cn-qv [data-cn-qv-select]');
    if (s && s.value) open(s.value);
  });
})();
